module.exports = __webpack_public_path__ + "media/images/athletes/3410-41b088c6e9371b355c77ebdf1e2465f5.png";